import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    setIsMobileMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const navItems = [
    { label: 'Início', id: 'home' },
    { label: 'Empresa', id: 'sobre-nos' },
    { label: 'Serviços', id: 'servicos' },
    { label: 'Galeria', id: 'galeria', isLink: true },
    { label: 'Contato', id: 'contato' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-[#010E31] shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-20 md:h-24">
          {/* Logo */}
          <div className="flex items-center">
            <img
              src="https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/63057d35168d881f87bd2e6d5389978b.png"
              alt="Alumi Innova Logo"
              className="h-24 md:h-32 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => (
              item.isLink ? (
                <Link
                  key={item.id}
                  to="/galeria"
                  className={`font-medium transition-colors duration-300 whitespace-nowrap cursor-pointer ${
                    isScrolled
                      ? 'text-white hover:text-[#C0C0C0]'
                      : 'text-white hover:text-[#C0C0C0]'
                  }`}
                >
                  {item.label}
                </Link>
              ) : (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className={`font-medium transition-colors duration-300 whitespace-nowrap cursor-pointer ${
                    isScrolled
                      ? 'text-white hover:text-[#C0C0C0]'
                      : 'text-white hover:text-[#C0C0C0]'
                  }`}
                >
                  {item.label}
                </button>
              )
            ))}
          </nav>

          {/* Desktop CTA Button */}
          <div className="hidden lg:block">
            <button
              onClick={() => window.open('https://api.whatsapp.com/send?phone=551974098245', '_blank')}
              className="bg-[#C0C0C0] hover:bg-[#A8A8A8] text-[#010E31] font-semibold px-6 py-2.5 rounded-lg transition-all duration-300 inline-flex items-center space-x-2 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              <span>WhatsApp</span>
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center transition-colors duration-300 cursor-pointer ${
              isScrolled ? 'text-white' : 'text-white'
            }`}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-3xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        <div
          className={`lg:hidden overflow-hidden transition-all duration-300 ${
            isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
          }`}
        >
          <nav className="py-4 space-y-2 bg-[#010E31] rounded-lg shadow-lg mb-4">
            {navItems.map((item) => (
              item.isLink ? (
                <Link
                  key={item.id}
                  to="/galeria"
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="block w-full text-left px-6 py-3 text-white hover:bg-white/10 hover:text-[#C0C0C0] font-medium transition-colors duration-300"
                >
                  {item.label}
                </Link>
              ) : (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="block w-full text-left px-6 py-3 text-white hover:bg-white/10 hover:text-[#C0C0C0] font-medium transition-colors duration-300 cursor-pointer"
                >
                  {item.label}
                </button>
              )
            ))}
            <div className="px-6 pt-2">
              <button
                onClick={() => {
                  setIsMobileMenuOpen(false);
                  window.open('https://api.whatsapp.com/send?phone=551974098245', '_blank');
                }}
                className="w-full bg-[#C0C0C0] hover:bg-[#A8A8A8] text-[#010E31] font-semibold px-6 py-3 rounded-lg transition-all duration-300 inline-flex items-center justify-center space-x-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                <span>WhatsApp</span>
              </button>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
}
